import React, {useState, useEffect} from 'react';
import RadioButton from "../RadioButton";
import { Trans, useLingui } from '@lingui/react/macro';

function PassengerConfirmationForm(props) {
    const [inputValue, setInputValue] = useState(null);
    const {t} = useLingui();

    const onSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(inputValue);
    }

    useEffect(() => {
        setInputValue(null);
    },[props.label]);

    return (
        <div className="my-4">
            <div className="my-4 text-lg text-grey-darker">
                {props.label}
            </div>
            <div>
                <form action="#" onSubmit={onSubmit}>
                    <RadioButton label={t({id: "Yes"})}
                                 _onChange={() => setInputValue(true)}
                                 isSelected={inputValue === true}/>

                    <div className="mt-4">
                        <RadioButton label={t({id: "no"})}
                                     _onChange={() => setInputValue(false)}
                                     isSelected={inputValue === false}/>
                     </div>


                    <button type="submit"
                            className={`mt-6 w-mobile action-button ${inputValue === null ? 
                                "action-button-disabled pointer-not-allowed" : 
                                "action-button-enabled"}`}>
                        <Trans id="next">Next</Trans>
                    </button>
                </form>
            </div>

        </div>
    )
}

export default PassengerConfirmationForm;